module.exports = __webpack_public_path__ + "img/3_5.bc1a6382.png";